import React, { PropsWithChildren, ReactElement } from 'react';
import { StyledFormWrapper } from './styles';

type FormWrapperProps = PropsWithChildren;

const FormWrapper = ({ children }: FormWrapperProps): ReactElement => (
  <StyledFormWrapper>{children}</StyledFormWrapper>
);

export default FormWrapper;
